import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material';
import { Alert, Grid, IconButton, Paper } from '@mui/material';
import { MAP_EVENTS, useMap } from 'es-map-widget';
import React, { useEffect, useRef, useState } from 'react';
import { MAP_LAYER_NAMES } from '../../constants/mapLayerNames';
import Legend from './components/Legend';
import { useLayout } from '../../providers/LayoutContext';

const excludedMaps = [
    MAP_LAYER_NAMES.OSM,
    MAP_LAYER_NAMES.BING,
    MAP_LAYER_NAMES.MEPAR,
    MAP_LAYER_NAMES.FIELDS,
    MAP_LAYER_NAMES.KARNAVI,
    MAP_LAYER_NAMES.SAMPLING,
    MAP_LAYER_NAMES.RADAR_MEPAR,
    MAP_LAYER_NAMES.HUNGARY_BOUNDARY,
    MAP_LAYER_NAMES.PLANT_OCCURRENCE,
];

const MapLegend = ({ bottom }) => {
    const { matchesLgUp } = useLayout();
    const map = useMap();
    const [layerVisibility, setVisibilityMap] = useState(
        Object.entries(map.getLayerVisibility())
            .filter(([layerName, visible]) => visible && !excludedMaps.includes(layerName))
            .map(([layerName]) => layerName)
    );
    const legendRef = useRef(null);
    const [legendScroll, setLegendScroll] = useState({ left: 0, leftMax: 0 });

    useEffect(() => {
        setVisibilityMap(
            Object.entries(map.getLayerVisibility())
                .filter(([layerName, visible]) => visible && !excludedMaps.includes(layerName))
                .map(([layerName]) => layerName)
        );
        const x = map.addEventListener(MAP_EVENTS.visibilityChange, (e) => {
            setVisibilityMap(
                Object.entries(e.layerVisibility)
                    .filter(([layerName, visible]) => visible && !excludedMaps.includes(layerName))
                    .map(([layerName]) => layerName)
            );
        });
        return () => {
            map.removeEventListener(MAP_EVENTS.visibilityChange, x);
        };
    }, [map, setVisibilityMap]);

    return (
        <Paper
            elevation={2}
            sx={{
                position: 'absolute',
                bottom,
                left: matchesLgUp ? 96 : 72,
                backgroundColor: '#fff',
                zIndex: 101,
                borderRadius: '10px',
                p: 0.625,
                maxWidth: matchesLgUp ? '856px' : 'calc(100% - 80px)',
            }}
        >
            <Grid container alignItems="center" wrap="nowrap">
                <Grid item>
                    <IconButton
                        disabled={
                            matchesLgUp
                                ? layerVisibility.length < 4 || legendScroll.left === 0
                                : legendScroll.left === 0
                        }
                        onClick={() => {
                            legendRef.current.scrollBy(-210, 0);
                        }}
                    >
                        <ChevronLeftRounded />
                    </IconButton>
                </Grid>
                <Grid
                    container
                    item
                    wrap="nowrap"
                    sx={{
                        overflow: 'auto hidden',
                    }}
                    ref={legendRef}
                    onScroll={() => {
                        setLegendScroll({
                            left: legendRef.current.scrollLeft,
                            leftMax: legendRef.current.scrollWidth - legendRef.current.clientWidth,
                        });
                    }}
                >
                    {layerVisibility.length === 0 && (
                        <Grid item sx={{ p: 1 }}>
                            <Alert severity="warning">Nincs réteg kiválasztva a térképen</Alert>
                        </Grid>
                    )}
                    {layerVisibility.map((e) => (
                        <Legend mapName={e} key={e} />
                    ))}
                </Grid>
                <Grid item>
                    <IconButton
                        disabled={
                            matchesLgUp
                                ? layerVisibility.length < 4 ||
                                  (legendScroll.left >= legendScroll.leftMax &&
                                      legendScroll.left !== 0)
                                : legendScroll.left >= legendScroll.leftMax &&
                                  legendScroll.left !== 0
                        }
                        onClick={() => {
                            legendRef.current.scrollBy(210, 0);
                        }}
                    >
                        <ChevronRightRounded />
                    </IconButton>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default MapLegend;
